import { createResource } from 'react-resource-router';
import { eocCommonResources } from '@atlassian/eoc-resources';
import { resources as scheduleCommonResources } from '@atlassian/eoc-schedule-common/resources';
import { getTeamIdFromContext } from '../../utils';
import { endpoints as editEndpoints } from '../endpoints/edit';
import { endpoints as listEndpoints } from '../endpoints/list';
import { endpoints as pageEndpoints } from '../endpoints/page';
import { endpoints as sectionEndpoints } from '../endpoints/section';
const getSchedulesResource = createResource({
  type: 'getSchedulesResource',
  getKey: () => 'getSchedulesResource',
  isBrowserOnly: true,
  getData: async routerExtendedContext => listEndpoints.getScheduleList(getTeamIdFromContext(routerExtendedContext))
});
const getUiPreferencesResource = createResource({
  type: 'getSchedulePreferencesResource',
  getKey: () => 'getSchedulePreferencesResource',
  isBrowserOnly: true,
  getData: async routerExtendedContext => pageEndpoints.getUiPreferences(getTeamIdFromContext(routerExtendedContext))
});
const getScheduleRightsResource = createResource({
  type: 'getScheduleRightsResource',
  getKey: () => 'getScheduleRightsResource',
  isBrowserOnly: true,
  getData: async routerExtendedContext => sectionEndpoints.getScheduleRights(getTeamIdFromContext(routerExtendedContext))
});
const getScheduleTimeTemplatesResource = createResource({
  type: 'getScheduleTimeTemplatesResource',
  getKey: () => 'getScheduleTimeTemplatesResourceurce',
  isBrowserOnly: true,
  getData: async () => editEndpoints.getScheduleTimeTemplates()
});
const resources = [getSchedulesResource, getUiPreferencesResource, getScheduleRightsResource, getScheduleTimeTemplatesResource, ...scheduleCommonResources, ...eocCommonResources()];
export { getSchedulesResource, getUiPreferencesResource, getScheduleRightsResource, getScheduleTimeTemplatesResource, resources };